// Success Page
export const HOMEPAGE_FETCHING = "HOMEPAGE_FETCHING";
export const HOMEPAGE_FAILED = "HOMEPAGE_FAILED";
export const HOMEPAGE_SUCCESS = "HOMEPAGE_SUCCESS";



export const AUTH_FETCHING = "AUTH_FETCHING";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const LOGOUT = "LOGOUT";


export const PRELIMINARY_FETCHING = "PRELIMINARY_FETCHING";
export const PRELIMINARY_FAILED = "PRELIMINARY_FAILED";
export const PRELIMINARY_SUCCESS = "PRELIMINARY_SUCCESS";
export const PRELIMINARY_FROM_SUCCESS = "PRELIMINARY_FROM_SUCCESS";
export const PRELIMINARY_FROM_STATUS = "PRELIMINARY_FROM_STATUS";

export const LOCATION_FETCHING = "LOCATION_FETCHING";
export const LOCATION_FAILED = "LOCATION_FAILED";
export const LOCATION_SUCCESS = "LOCATION_SUCCESS";
export const LOCATION_PROVINCE_SUCCESS = "LOCATION_PROVINCE_SUCCESS";
export const LOCATION_SUBDISTRICT_SUCCESS = "LOCATION_SUBDISTRICT_SUCCESS";
export const LOCATION_DISTRICT_SUCCESS = "LOCATION_DISTRICT_SUCCESS";
export const LOCATION_AMPHURE_SUCCESS = "LOCATION_AMPHURE_SUCCESS";
export const LOCATION_MOO_SUCCESS = "LOCATION_MOO_SUCCESS";
export const LOCATION_COMMUNITY_SUCCESS = "LOCATION_COMMUNITY_SUCCESS";


export const LOCATION_FETCHING_2 = "LOCATION_FETCHING_2";
export const LOCATION_FAILED_2 = "LOCATION_FAILED_2";
export const LOCATION_SUCCESS_2 = "LOCATION_SUCCESS_2";
export const LOCATION_PROVINCE_SUCCESS_2 = "LOCATION_PROVINCE_SUCCESS_2";
export const LOCATION_SUBDISTRICT_SUCCESS_2 = "LOCATION_SUBDISTRICT_SUCCESS_2";
export const LOCATION_DISTRICT_SUCCESS_2 = "LOCATION_DISTRICT_SUCCESS_2";
export const LOCATION_AMPHURE_SUCCESS_2 = "LOCATION_AMPHURE_SUCCESS_2";
export const LOCATION_MOO_SUCCESS_2 = "LOCATION_MOO_SUCCESS_2";
export const LOCATION_COMMUNITY_SUCCESS_2 = "LOCATION_COMMUNITY_SUCCESS_2";

export const ASSESSMENT_FETCHING = "ASSESSMENT_FETCHING";
export const ASSESSMENT_FAILED = "ASSESSMENT_FAILED";
export const ASSESSMENT_SUCCESS = "ASSESSMENT_SUCCESS";

export const WORKPLAND_FETCHING = "WORKPLAND_FETCHING";
export const WORKPLAND_FAILED = "WORKPLAND_FAILED";
export const WORKPLAND_SUCCESS = "WORKPLAND_SUCCESS";

export const NEWS_FETCHING = "NEWS_FETCHING";
export const NEWS_FAILED = "NEWS_FAILED";
export const NEWS_SUCCESS = "NEWS_SUCCESS";

export const REPORT_FETCHING = "REPORT_FETCHING";
export const REPORT_FAILED = "REPORT_FAILED";
export const REPORT_SUCCESS = "REPORT_SUCCESS";
export const REPORT_FORM_NO_SUCCESS = "REPORT_FORM_NO_SUCCESS";
export const REPORT_DEV5_DASHBOARD_SUCCESS = "REPORT_DEV5_DASHBOARD_SUCCESS";

export const NOTIFICATION_FETCHING = "NOTIFICATION_FETCHING";
export const NOTIFICATION_FAILED = "NOTIFICATION_FAILED";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";

export const OFFICER_ADMIN_FETCHING = "OFFICER_ADMIN_FETCHING";
export const OFFICER_ADMIN_FAILED = "OFFICER_ADMIN_FAILED";
export const OFFICER_ADMIN_SUCCESS = "OFFICER_ADMIN_SUCCESS";

export const NEWS_ADMIN_FETCHING = "NEWS_ADMIN_FETCHING";
export const NEWS_ADMIN_FAILED = "NEWS_ADMIN_FAILED";
export const NEWS_ADMIN_SUCCESS = "NEWS_ADMIN_SUCCESS";

export const CHILD_ADMIN_FETCHING = "CHILD_ADMIN_FETCHING";
export const CHILD_ADMIN_FAILED = "CHILD_ADMIN_FAILED";
export const CHILD_ADMIN_SUCCESS = "CHILD_ADMIN_SUCCESS";

export const CHILD_CONNECT_ADMIN_FETCHING = "CHILD_CONNECT_ADMIN_FETCHING";
export const CHILD_CONNECT_ADMIN_FAILED = "CHILD_CONNECT_ADMIN_FAILED";
export const CHILD_CONNECT_ADMIN_SUCCESS = "CHILD_CONNECT_ADMIN_SUCCESS";

export const DEPARTMENT_ADMIN_FETCHING = "DEPARTMENT_ADMIN_FETCHING";
export const DEPARTMENT_ADMIN_FAILED = "DEPARTMENT_ADMIN_FAILED";
export const DEPARTMENT_ADMIN_SUCCESS = "DEPARTMENT_ADMIN_SUCCESS";

//dev
export const apiUrl = (process.env.REACT_APP_MODE === "DEV" ? process.env.REACT_APP_URL_API_DEV : process.env.REACT_APP_URL_API);
// export const apiUrl = 'https://wmhealth-backoffice-api.darwintec.co.th/api/';

export const imageUrl = "http://localhost:8085";

//production
// export const apiUrl = "http://localhost:8085/api/v2";
// export const imageUrl = "http://localhost:8085";

export const YES = "YES";
export const NO = "NO";
export const OK = "ok";
export const NOK = "nok";
export const TOKEN = "TOKEN";

export const LOGIN_STATUS = "LOGIN_STATUS";

export const server = {

  //AUTH
  LOGIN_PASSED: `yes`,
  LOGIN_API: `authen/login`,
  // REGISTER_URL: `auth/line-register`,
  REGISTER_URL: `auth/user-register`,
  
  REGISTER_PARENT_URL: `parent/registerWithKid`,
  LOGOUT_URL:`auth/logout`,
  LOGINBYUSERNAME_URL: `auth/login`,
  MATECH_USER: `auth/line-auth`,
  GET_KID_URL: `kid/list-kid`,
  GET_KID_BY_SCHOOL_URL: `school/getKid`,
  GET_DASHBOARD_KID_BY_SCHOOL_URL: `report/dashboard/school/getKid`,
  GET_KID_BY_USER_URL: `kid/list-kid-by-user`,
  GET_KID_BY_PARENT_URL: `parent/getKid`,
  GET_KID_BY_ADMIN_URL: `kid/list-kid-by-admin`,
  GET_KID_FOR_LOCATION_REPORT_URL: `kid/kid-area`,
  GET_KID_AREA_BY_USER_URL: `kid/kid-area-by-user`,
  GET_KID_ALL_URL: `kid/list-kid-by-admin`,
  GET_KID_BY_AREA_URL: `kid/list-kid`,
  GET_KID_BY_USER_2: `backoffice/kid/getByUser`,
  GET_KID_IN_OUT: `kid/kidStatus3`,
  GET_KID_PLAN_URL: `backoffice/kid`,

  
  GET_PROCINCE_URL: `address/province`,
  GET_DISTRICT_URL: `address/district`,
  GET_SUB_DISTRICT_URL: `address/subdistrict`,
  GET_MOO_URL: `address/moo`,
  GET_community_URL: `address/community`,
  GET_NANNY_URL: `kid/nanny`,

  // GET_DEVELOPMENTFORM_URL: `development`,
  GET_DEVELOPMENTFORM_URL: `development/form`,
  ADD_DEVELOPMENTFORM_URL: `development/record`,
  // ADD_DEVELOPMENTFORM_URL: `development/addTest`,

  GET_FROM_URL: `development/kid`,
  // ADD_DEVELOPMENTFORM_URL: `development/record`,

  GET_KIDACTION_LOGS_URL:`kidAction/logs`,
  ADD_CHILD_URL:`kid/create`,
  CONFIRM_APPROVE_URL:`kidAction/create`,
  CONFIRM_APPROVE_UNKNOWN_URL:`backoffice/kid/setOutOfArea`,
  UPDATE_APPROVE_URL:`kidAction/update/`,
  UPDATE_LOCATION_URL:`kidAction/edit`,
  ADMIN_UPDATE_APPROVE_URL:`backoffice/kid/addKidArea`,
  CHECK_PID_URL:`kid/pid`,
  CHECK_PID_PARENT_URL:`parent/getKidWithPid`,
  DELETE_KID_URL:`parent/deleteKid`,
  OFFICEALERT_URL:`development/officerAlert`,
  
//ดูผลการคัดกรอง
  HISTORY_DEVELOPMENTFORM_URL:`development/history`,

  HISTORY_DEVELOPMENTFORM_BYID_URL: `development/form`,
  HISTORY_DEVELOPMENTFORM_BYRECORDID_URL: `development/historyByid`,
  GET_DEFECTIVE:`defective`,

  GETPLAN_URL: `plan`,
  GETPLAN_BY_USER_URL: `plan`,
  GETKID_URL: `plan/getKid`,
  GETKID_BY_USER_URL: `plan/byUser`,

  ADD_KID_TO_PLAND_DATE_URL: `plan/addKid`,
  PLAN_REMOVE_KID: `plan/removeKid`,

  GET_NEWS_URL: `content/list`,
  // GET_NEWS_URL: `backoffice/content`,
  GET_NEWS_BY_ID_URL: `content/viewer/`,
  GET_NEWS_BY_DOWNLOAD_URL: `content/downloads/`,

  LINK_USER:`backoffice/user/link/uuid`,

  GET_NOTIFICATIONS_URL: `alert/`,

  GET_OFFICER_ADMIN_URL: `backoffice/user`,
  UPDATE_USER_URL: `backoffice/user/updateProfile`,
  GET_OFFICER_ADMIN_ROLE_URL: `backoffice/user/userRole`,
  UPDATE_OFFICER_ADMIN_ROLE_URL: `backoffice/user/userRole/update`,
  UPDATE_INCOMPLETE_URL:`auth/updateUser`,

  OFFICER_ADMIN_APPROVE_URL:`backoffice/user/status/update`,
  GET_NEWS_ADMIN_URL: `backoffice/content`,
  UPLOAD_FILE_KIDS_URL:`/backoffice/upload/uploads/kid`,
  UPLOAD_FILE_PERSONNEL_URL:`/backoffice/upload/uploads`,

  
  GET_CHILD_ADMIN_URL: `backoffice/kid`,
  getKidWithPagination : `backoffice/kid/getKidWithPagination`,
  GET_CHILD_ADMIN_FOR_REPORT_URL: `report/dashboard/kid/area`,
  GET_CHILD_USER_FOR_REPORT_URL: `report/dashboard/user/kid/area`,
  GET_CHILD_PARENT_FOR_REPORT_URL: `parent/getKid`,
  GET_CHILD_ADMIN_BY_AREA_URL: `backoffice/kid/getByArea`,
  GET_CHILD_ADMIN_BY_User_URL: `backoffice/kid/getByUser`, 
  GET_CHILD_OUT_OF_AREA_URL: `/backoffice/kid/outOfArea`,
  GET_CHILD_IS_NOT_COMPLETE_URL: `backoffice/kid/incomplete`,
  

  GET_HEAL_RECORD_CHOICE_ADMIN_URL: `api/healthKid/choice`,
  GET_HEAL_RECORD_URL: `api/healthKid`,


  GET_CHILD_OF_AGE_URL:`backoffice/kid/outOfAge`,

  GET_USERS_ADMIN_BY_AREA_URL: `backoffice/user/getByArea`,
  GET_USERS_ROLE_ADMIN_BY_AREA_URL: `backoffice/user/userRole/getByArea`,
  GET_USERS_ADMIN_URL: `backoffice/user/getAll`,
  GET_USERS_AREA_URL: `backoffice/user/getByArea`,
  GET_USERS_BY_NAME_URL: `backoffice/user/name`,

  UPDATE_CONNECT_ADMIN_URL:`backoffice/kid/user`,

  CHILD_CONNECT_URL:`parent/addKid`,

  DEPARTMENT_ADMIN_URL:`department`,
  DEPARTMENT_ROLE_ADMIN_URL:`/backoffice/role`,
  ADD_AREA_DEPARTMENT_ADMIN_URL: `department/area`,
  GET_DEVELOPMENT_HISTORY: `development/history`,

  // GET_REPORT_URL: `report/dashboard/reportKidByArea`,
  GET_REPORT_URL: `report/dashboard/user`,
  GET_REPORT_AREA_URL: `report/dashboard/area`,
  GET_REPORT_SCHOOL_URL: `report/dashboard/school`,

  GET_REPORT_PARENT_URL: `report/dashboard/parent`,

  DOWNLOAD_REPORT_MONTH_URL: `report/reportMonthKidByArea`,
  DOWNLOAD_REPORT_YEAR_URL: `report/reportYearKidByArea`,
  DOWNLOAD_REPORT_CHILD_URL: `report/reportKid`,
  DOWNLOAD_REPORT_DEV5_URL: `report/reportGroupCode`,

 DOWNLOAD_REPORT_USER_BY_AREA_URL: `/report/reportUserByArea`,
 DOWNLOAD_REPORT_USER_DETAILS_URL: `/report/reportUserDetails`,

 DOWNLOAD_REPORT_YEAR_SCHOOL_URL: `report/school/reportYearKid`,
 DOWNLOAD_REPORT_MONTH_SCHOOL_URL: `report/school/reportMonthKid`,
 
 DOWNLOAD_REPORT_YEAR_PARENT_URL: `report/parent/reportYearKid`,
 DOWNLOAD_REPORT_MONTH_PARENT_URL: `report/parent/reportMonthKid`,

 
  GET_FORMNO_URL:`util/formno`,
  GET_GROUPCODE_URL:`util/groupcode`,
  GET_DASHBOARD_GROUPCODE:`report/dashboard/groupcode`,
  GET_DASHBOARD_GROUPCODE_USER:`report/dashboard/user/groupcode`,
  GET_CHARTDEV5DASHBOARD_GROUPCODE:`report/dashboard/groupcodeScore`,
  GET_CHARTDEV5DASHBOARD_GROUPCODE_USER:`report/dashboard/user/groupcodeScore`,
  GET_CHARTDEV5DASHBOARD_SCHOOL:`report/dashboard/school/groupcodeScore`,
  GET_REPORT_GROUPCODE_PARENT:`report/parent/reportGroupCode`,
  GET_CHARTDEV5DASHBOARD_PARENT:`report/dashboard/parent/groupcodeScore`,


  

}; 

// Error Code
export const E_PICKER_CANCELLED = "E_PICKER_CANCELLED";
export const E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR =
  "E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR";
export const E_PERMISSION_MISSING = "E_PERMISSION_MISSING";
export const E_PICKER_NO_CAMERA_PERMISSION = "E_PICKER_NO_CAMERA_PERMISSION";
export const E_USER_CANCELLED = "E_USER_CANCELLED";
export const E_UNKNOWN = "E_UNKNOWN";
export const E_DEVELOPER_ERROR = "E_DEVELOPER_ERROR";
export const TIMEOUT_NETWORK = "ECONNABORTED"; // request service timeout
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  "An error has occurred. The photo was unable to upload.";
